<div class="sub-category-list">
  <ng-container *ngIf="showSubCategories && subCategoryDisplayList.length > 0">
    <h1>{{subCategoryDisplayList[0]?.title}}</h1>
    <div class="cat-list">
      <ng-container *ngFor="let item of subCategoryDisplayList">
        <a class="cat-item" [routerLink]="['/' + item.key]">
          <img class="cat-image" [src]="item?.img" alt="">
          <p class="cat-name">{{item?.name}}</p>
        </a>
      </ng-container>
    </div>
  </ng-container>
  <div class="blog-content" *ngIf="showBlogContent && blogContent">
    <h2 class="cc-head" *ngIf="city">Book the best {{service | slugText : 'capitalize'}} in {{city | slugText : 'capitalize'}}</h2>
    <div [innerHTML]="blogContent"></div>
  </div>
</div>
